module.exports = __webpack_public_path__ + "img/circles.f5124f60.svg";